module.exports = __webpack_public_path__ + "img/logo.d30a4702.jpg";